
  import { defineComponent, ref } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import moment from 'moment';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import { BankRatesLogReportsFilterInfo } from '@/store/modules/BankRatesModule';

  export default defineComponent({
    name: 'bank-rates-filter',
    emit: ['filter-rates-selected', 'reset'],
    components: {},
    async setup(props, { emit }) {
      const { t, te } = useI18n();
      const selectedItems = ref<BankRatesLogReportsFilterInfo>({
        dateFrom: '',
        dateTo: '',
        action: '',
        status: '',
      });
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        if (selectedItems.value.dateFrom) {
          selectedItems.value.dateFrom = moment(
            selectedItems.value.dateFrom
          ).format('YYYY-MM-DD');
        }
        if (selectedItems.value.dateTo) {
          selectedItems.value.dateTo = moment(
            selectedItems.value.dateTo
          ).format('YYYY-MM-DD');
        }
        emit('filter-rates-selected', selectedItems);
      };

      const onReset = () => {
        selectedItems.value = {
          dateFrom: '',
          dateTo: '',
          action: '',
          status: '',
        };
        emit('reset', selectedItems.value);
      };

      reinitializeComponents();

      return {
        onSubmit,
        onReset,
        selectedItems,
        translate,
      };
    },
  });
